var React = require('react');

function ArrowRightIcon (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"9.29742","y1":"8.61013","x2":"1.29742","y2":"0.711597","stroke":"#212121","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"1.38984","y1":"15.1959","x2":"9.28837","y2":"7.19595","stroke":"#212121","strokeWidth":"2","key":1})]);
}

ArrowRightIcon.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = ArrowRightIcon;

ArrowRightIcon.default = ArrowRightIcon;
